
import TableList from "@components/templates/tablelist";
import { HttpMaterialCostList, HttpExportMaterialCost } from "@/service/costbilling";
import { mapGetters } from "vuex";
import comExcel from '@components/templates/excelalert';
export default {
    mixins: [TableList],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: { show: true },
            formData: {

            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpMaterialCostList,
        handleOperates(params = "", type, batch) {
            // if (batch === true) {
            //     params = (params || this.checkedData.join(',')) + '';
            //     if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            // }
            switch (type) {
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/billingCostMaterialDetail/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    ).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList','getAdminTransferWarehouse', 'getBillcusWareList', 'getCusproductList']),
        ToolsData() {
            return [
                {
                    label: "导出",
                    operate: "export",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "组织",
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    options: this.getBillcusorgList,
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "仓库",
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getAdminTransferWarehouse,
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "账单",
                    tag: 'vInput',
                    key: 'EQ_billNo',
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getCusproductList,
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "包材Code",
                    tag: 'vInput',
                    key: 'EQ_materialCode',
                },
                {
                    label: "计费单号",
                    tag: 'vInput',
                    key: 'EQ_orderNo',
                },
                {
                    label: "Tracking No",
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                },
                // {
                //     label: "状态",
                //     key: 'EQ_billId',
                //     more: true,
                //     tag: 'vSelect',
                //     options: this.getBillingDetailStatus,
                //     props: {
                //         filterable: true,
                //     },
                // },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    style: "width:362px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                }
            ]
        },
        columns() {
            return [{
                title: '组织/仓库',
                render: (h, { row }) => {
                    let orgId = row.orgId
                    const { label } = this.getBillcusorgList.find(function (item) {
                        return item.value == orgId
                    }) || {};
                    return <div>
                        <div>{label || '--'}</div>
                        <div>{row.warehouseCode || '--'}</div>
                    </div>
                }
            },
            {
                title: '账单',
                key: 'billNo',
                render: (h, { row }) => {
                    return <div>
                        账单 : {row.billNo}
                        <div>状态:{row.billId == 0 ? '未出账' : '已出账'}</div>
                    </div>
                }
            },
            {
                title: '包材',
                key: 'materialName',
            },
            {
                title: '费率*数量',
                render: (h, { row }) => {
                    return <div>
                        {row.baseRate} * {row.qty}
                    </div>
                }
            },
            {
                title: '总费用',
                key: 'cost',
                render(h, { row }) {
                    return `${row.cost} ${row.currency || 'USD'}`
                }
            },
            {
                title: '计费单号/识别号/Tracking No',
                width: 180,
                render: (h, { row }) => {
                    return <div>
                        {row.orderNo || '--'}
                        <div>{row.sourceNo || '--'}</div>
                        <div>{row.trackingNo || '--'}</div>
                    </div>
                }
            },
            {
                title: '项目/备注',
                key: 'lineId',
                render: (h, { row }) => {
                    let lineId = row.lineId
                    const { label } = this.getCusproductList.find(function (item) {
                        return item.value == lineId
                    }) || {};
                    return <div>
                        {label || '--'}
                        <div>{row.remark || '--'}</div>
                    </div>
                }
            },
            {
                title: '创建日期',
                key: 'createdAt',
                sortable: true
            }
            ];
        },

    },

};
